import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

import { setExistingCategories } from 'redux/categories/cat.actions';
import {
  getAllCategoriesFromDb,
  getAllocatedUrls,
  saveUpdatedUrlToDb
} from './api';
import MenuBar from './components/MenuBar';
import Alert from 'common-components/Alert';
import {
  SERVER_ERROR,
  LOGIN_ERROR
} from 'common-components/Alert/alertMessage.config';
import {
  setUnpublishedURLs,
  setURLStatusAsReviewed,
  setURLStatusAsIgnored,
  setFilteredURLStatusAsIgnored,
  setFilteredURLStatusAsReviewed,
  setRevisedCatForFilteredURls,
  setRevisedCategory
} from 'redux/urls/url.action';
import {
  prepareCatForDropdown,
  setPayloadToSaveUrl,
  raiseEmptyData,
  raiseNullInput
} from './utils';
import UrlReviewModal from './components/UrlReviewModal';
import UrlTable from './components/UrlTable';
import PublishNotification from './components/PublishNotification';

import './reviewQueue.style.css';


const ReviewQueue = ({
  authHeader,
  unPublishedUrls,
  filteredUrls,
  publishNotificationSummary,
  existingCategories,
  setUnpublishedURLs,
  setExistingCategories,
  setURLStatusAsReviewed,
  setURLStatusAsIgnored,
  setFilteredURLStatusAsIgnored,
  setFilteredURLStatusAsReviewed,
  setRevisedCatForFilteredURls,
  setRevisedCategory
}) => {
  const [alertData, setAlertData] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [inputCatList, setInputCatList] = useState(null);
  const [revisedCat, setRevisedCat] = useState(null);
  const [notify, setNotify] = useState(false);
  const [saveSpinner, setSaveSpinner] = useState(false);
  const [saveAndNextSpinner, setSaveAndNextSpinner] = useState(false);
  const [ignoreSpinner, setIgnoreSpinner] = useState(false);
  const [ignoreAndNextSpinner, setIgnoreAndNextSpinner] = useState(false);
  const [currentEditingRow, setCurrentEditingRow] = useState({
    row: null,
    showModal: false,
    getNextRow: null
  });

  const loadAllocatedUrls = async () => {
    let data;

    let response = await getAllocatedUrls(authHeader);
    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    else if (response && response.status == 204) raiseEmptyData(setAlertData);
    else if (response && response.status.toString().match(/2\d{2}/)) data = response.data;
    else setAlertData(SERVER_ERROR);

    setUnpublishedURLs(data);
    return true;
  };

  const setTableData = async () => {
    let status = await loadAllocatedUrls();
    status && setLoading(false);
  };

  useEffect(() => {
    if (existingCategories) {
      let catList = prepareCatForDropdown(existingCategories);
      setInputCatList(catList);
    } else {
      loadAllcategories();
    };
  }, [existingCategories]);

  useEffect(() => {
    setLoading(true);

    if (unPublishedUrls) {
      setLoading(false);
    } else {
      setTableData();
    };
  }, [unPublishedUrls]);

  useEffect(() => {
    if (publishNotificationSummary) setNotify(true);
  }, [publishNotificationSummary]);

  const loadAllcategories = async () => {
    let data;
    let response = await getAllCategoriesFromDb(authHeader);

    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    else if (response && response.status.toString().match(/2\d{2}/)) data = response.data.results;
    else setAlertData(SERVER_ERROR);

    setExistingCategories(data);
  };

  const initiateSaveUrlToDb = async (id, payload) => {
    let response = await saveUpdatedUrlToDb(authHeader, id, payload);

    if (response && response.status == 401) {
      setAlertData(LOGIN_ERROR);
    } else if (response && (response.status.toString().match(/2\d{2}/))) {
      return true;
    } else {
      setAlertData(SERVER_ERROR);
      return false;
    };
  };

  const handleRowEdit = (row, getNextRowFunc) => {
    setCurrentEditingRow({ row, getNextRow: getNextRowFunc, showModal: true })
  };

  const handleSaveAndNext = async (updatedRow) => {
    if (revisedCat) {
      let payload = setPayloadToSaveUrl(revisedCat, false);
      setSaveAndNextSpinner(true);

      let success = await initiateSaveUrlToDb(currentEditingRow.row.id, payload);
      success && filterApplied && setFilteredURLStatusAsReviewed({ urls: filteredUrls, id: currentEditingRow.row.row_id });
      success && setURLStatusAsReviewed({ urls: unPublishedUrls, id: currentEditingRow.row.row_id });
      success && filterApplied && setRevisedCatForFilteredURls({ urls: filteredUrls, id: currentEditingRow.row.row_id, revisedCategory: revisedCat });
      success && setRevisedCategory({ urls: unPublishedUrls, id: currentEditingRow.row.row_id, revisedCategory: revisedCat });
      setSaveAndNextSpinner(false);

      const nextRow = currentEditingRow.getNextRow(updatedRow.id);
      if (nextRow) setCurrentEditingRow({ ...currentEditingRow, row: nextRow });
      else setCurrentEditingRow({ showModal: false });
    } else {
      raiseNullInput(setAlertData);
    };
  };

  const handleIgnoreAndNext = async (updatedRow) => {
    let payload = setPayloadToSaveUrl(revisedCat, true);
    setIgnoreAndNextSpinner(true);

    let success = await initiateSaveUrlToDb(currentEditingRow.row.id, payload);
    success && filterApplied && setFilteredURLStatusAsIgnored({ urls: filteredUrls, id: currentEditingRow.row.row_id });
    success && setURLStatusAsIgnored({ urls: unPublishedUrls, id: currentEditingRow.row.row_id });
    setIgnoreAndNextSpinner(false);

    const nextRow = currentEditingRow.getNextRow(updatedRow.id);

    if (nextRow) setCurrentEditingRow({ ...currentEditingRow, row: nextRow })
    else setCurrentEditingRow({ showModal: false })
  };

  const handleSave = async () => {
    if (revisedCat) {
      let payload = setPayloadToSaveUrl(revisedCat, false);
      setSaveSpinner(true);

      let success = await initiateSaveUrlToDb(currentEditingRow.row.id, payload);
      success && filterApplied && setFilteredURLStatusAsReviewed({ urls: filteredUrls, id: currentEditingRow.row.row_id });
      success && setURLStatusAsReviewed({ urls: unPublishedUrls, id: currentEditingRow.row.row_id });
      success && filterApplied && setRevisedCatForFilteredURls({ urls: filteredUrls, id: currentEditingRow.row.row_id, revisedCategory: revisedCat });
      success && setRevisedCategory({ urls: unPublishedUrls, id: currentEditingRow.row.row_id, revisedCategory: revisedCat });
      setSaveSpinner(false);

      setCurrentEditingRow({ showModal: false });
    } else {
      raiseNullInput(setAlertData);
    };
  };

  const handleIgnore = async () => {
    let payload = setPayloadToSaveUrl(revisedCat, true);
    setIgnoreSpinner(true);

    let success = await initiateSaveUrlToDb(currentEditingRow.row.id, payload);
    success && filterApplied && setFilteredURLStatusAsIgnored({ urls: filteredUrls, id: currentEditingRow.row.row_id });
    success && setURLStatusAsIgnored({ urls: unPublishedUrls, id: currentEditingRow.row.row_id });
    setIgnoreSpinner(false);

    setCurrentEditingRow({ showModal: false });
  };

  const memoUrlTable = useMemo(() => {
    return (
      <UrlTable
        isLoading={isLoading}
        tableData={filterApplied ? filteredUrls : unPublishedUrls ? unPublishedUrls : []}
        onRowEdit={handleRowEdit}
      />
    )
  }, [unPublishedUrls, isLoading, filteredUrls, filterApplied]);

  return (
    <>
      <div className='review-table-container'>
        <MenuBar
          isLoading={isLoading}
          filterApplied={filterApplied}
          setFilterApplied={setFilterApplied}
          dropDownCat={inputCatList}
        />
        {memoUrlTable}
      </div >
      <UrlReviewModal
        show={currentEditingRow && currentEditingRow.showModal}
        rowData={currentEditingRow.row}
        onSave={handleSave}
        onIgnore={handleIgnore}
        onSaveAndNext={handleSaveAndNext}
        onIgnoreAndNext={handleIgnoreAndNext}
        onClose={() => setCurrentEditingRow({ showModal: false })}
        dropDownCat={inputCatList}
        revisedCat={revisedCat}
        setRevisedCat={setRevisedCat}
        saveSpinner={saveSpinner}
        saveAndNextSpinner={saveAndNextSpinner}
        ignoreSpinner={ignoreSpinner}
        ignoreAndNextSpinner={ignoreAndNextSpinner}
      />
      {notify && (
        <PublishNotification
          publishNotificationSummary={publishNotificationSummary}
        />
      )}
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </>
  );
};

const mapStateToProps = ({
  authentication: { authHeader },
  categories: { existingCategories },
  URLs: { unPublishedUrls, filteredUrls, publishNotificationSummary } }) => ({
    authHeader,
    existingCategories,
    unPublishedUrls,
    filteredUrls,
    publishNotificationSummary
  });

const mapDispatchToProps = dispatch => ({
  setExistingCategories: categories => dispatch(setExistingCategories(categories)),
  setUnpublishedURLs: urls => dispatch(setUnpublishedURLs(urls)),
  setURLStatusAsReviewed: payload => dispatch(setURLStatusAsReviewed(payload)),
  setURLStatusAsIgnored: payload => dispatch(setURLStatusAsIgnored(payload)),
  setFilteredURLStatusAsReviewed: payload => dispatch(setFilteredURLStatusAsReviewed(payload)),
  setFilteredURLStatusAsIgnored: payload => dispatch(setFilteredURLStatusAsIgnored(payload)),
  setRevisedCategory: payload => dispatch(setRevisedCategory(payload)),
  setRevisedCatForFilteredURls: payload => dispatch(setRevisedCatForFilteredURls(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewQueue);
